<template>
  <div id="app">
    <div v-if="isPage" :class="[{'disable-animation' : disableAnimation}, {'global-visibility': globalVisibility}, {'app-retina': isRetina()}, {'theme-switching-ending' : themeSwitchingEnding}, {'popup-open': popup}, {'app-loading': firstVisitAnimation && $route.path === '/'}, `app-${browser}`, `app-${mobile ? 'low' : 'high'}`, `app-${lang === 0 ? 'ru' : 'en'}`]">
      <Heady/>
      <SwitcherButton v-if="!themeOnlyWhite"/>

      <div :class="`page-theme page-theme-${theme}`">

        <div v-in-viewport="50" ref="home" class="page-theme">
          <div style="z-index: -1" class="page-pseudo">
            <div class="background background-active">
              <div class="background-back">
                <div class="background-video-gradient">
                  <video v-if="graphicLevel > graphicLimit - 2 && !mobile" ref="background0" loop muted autoplay>
                    <source :src="`/static/sotbi_cover_1${graphicLevel < graphicLimit ? '_low' : ''}.webm`" type="video/webm">
                    <source :src="`/static/sotbi_cover_1${graphicLevel < graphicLimit ? '_low' : ''}.mp4`" type="video/mp4">
                    <source :src="`/static/sotbi_cover_1${graphicLevel < graphicLimit ? '_low' : ''}.ogv`" type="video/ogv">
                  </video>
                </div>
              </div>
            </div>
            <div class="background-video-gradient"/>
          </div>

          <div class="page-back">
            <HomeDark/>
          </div>

          <div class="page-front">
            <div class="background background-active">
              <div class="background-back background-back-white"/>
            </div>
            <Home/>
            <PageMask1/>
          </div>

        </div>

        <div v-in-viewport ref="service" class="page-theme">

          <div class="page-pseudo">
            <ServiceAnimation />
          </div>

          <div class="page-back">
            <ServiceDark/>
          </div>

          <div class="page-front">
            <Service/>
            <PageMask1/>
          </div>
        </div>

        <div v-in-viewport="50" ref="clients" class="page-theme page-with-popup">
          <div class="background background-active background-video-second">
            <div class="background-video-gradient">
              <video v-if="graphicLevel > graphicLimit - 2 && !mobile" ref="background2" loop muted autoplay>
                <source :src="`/static/vid_2${graphicLevel < graphicLimit ? '_low' : ''}.webm`" type="video/webm">
                <source :src="`/static/vid_2${graphicLevel < graphicLimit ? '_low' : ''}.mp4`" type="video/mp4">
                <source :src="`/static/vid_2${graphicLevel < graphicLimit ? '_low' : ''}.ogv`" type="video/ogv">
              </video>
            </div>
            <div class="background-video-gradient"/>
          </div>
          <div class="page-back">
            <ClientsDark/>
          </div>
          <div class="page-front">
            <Clients/>
            <PageMask1/>
          </div>
        </div>


        <div v-in-viewport="50" ref="about" class="page-theme">
          <div class="page-back">
            <AboutUsDark/>
          </div>
          <div class="page-front">
            <AboutUs/>
            <PageMask1/>
          </div>
          <div class="page-pseudo">
            <AboutUsMap/>
          </div>
        </div>

        <div v-in-viewport="50" ref="career" class="page-theme">
          <div class="page-back page-visible">
            <CareerDark/>
          </div>
          <div class="page-front">
            <Career/>
          </div>
          <div class="page-pseudo">
            <CareerImages/>
          </div>
        </div>

        <div v-in-viewport="50" ref="contacts" class="page-theme">
          <div class="page-back">
            <ContactsDark/>
            <div style="opacity: 0">
              <PageMask4/>
            </div>
            </PageMask4div>
            <ContactMap ref="mapSotbiDark" dark="true"/>
          </div>
          <div class="page-front page-front-contacts">
            <Contacts/>
            <PageMask4/>
          </div>
          <div class="map-standard">
            <ContactMap ref="mapSotbi"/>
          </div>
        </div>

        <!-- </template> -->
      </div>

      <PopupDocuments v-if="popup && !firstVisitAnimation"/>
      <Preloader/>
      <!-- <div  v-if="firstVisitAnimation" class="preloader--mini">
        <img class="preloader-progress" src="/static/preloader.gif"/>
      </div> -->

    </div>
    <div v-else>
      <Error404/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SwitcherButton from '@/components/SwitcherButton';

import PageMask1 from '@/components/Masks/Mask1';
import PageMask2 from '@/components/Masks/Mask2';
import PageMask3 from '@/components/Masks/Mask3';
import PageMask4 from '@/components/Masks/Mask4';

import Heady from '@/layouts/Heady';
import Home from '@/pages/Home';
import HomeDark from '@/pages/HomeDark';
import Service from '@/pages/Service';
import ServiceDark from '@/pages/ServiceDark';
import ServiceAnimation from '@/pages/ServiceAnimation';
import Clients from '@/pages/Clients';
import ClientsDark from '@/pages/ClientsDark';
import AboutUs from '@/pages/AboutUs';
import AboutUsMap from '@/pages/AboutUsMap';
import AboutUsDark from '@/pages/AboutUsDark';
import Career from '@/pages/Career';
import CareerImages from '@/pages/CareerImages';
import CareerDark from '@/pages/CareerDark';
import Contacts from '@/pages/Contacts';
import ContactsDark from '@/pages/ContactsDark';
import Error404 from '@/pages/404';

import ContactMap from '@/components/Map';

import PopupDocuments from '@/components/PopupDocuments';
import Preloader from '@/components/Preloader';

import inViewport from '@/helpers/viewport';

export default {
  components: {
    PopupDocuments,
    SwitcherButton,
    PageMask1,
    PageMask2,
    PageMask3,
    PageMask4,
    ContactsDark,
    Contacts,
    AboutUsDark,
    AboutUsMap,
    AboutUs,
    ClientsDark,
    Clients,
    Career,
    CareerDark,
    CareerImages,
    ServiceAnimation,
    ServiceDark,
    Service,
    Heady,
    HomeDark,
    Home,
    ContactMap,
    Error404,
    Preloader,
  },
  computed: mapGetters({
    themeSwitchingEnding: 'themeSwitchingEnding',
    firstVisitAnimation: 'firstVisitAnimation',
    globalVisibility: 'globalVisibility',
    themeIsSwitched: 'themeIsSwitched',
    themeOnlyWhite: 'themeOnlyWhite',
    firstVisit: 'firstVisit',
    animation: 'animation',
    browser: 'browser',
    loaded: 'loaded',
    mobile: 'mobile',
    theme: 'theme',
    popup: 'popup',
    page: 'page',
    lang: 'lang',
  }),
  data() {
    return {
      disableAnimation: false,
      animationTimeout: null,
      switchedTheme: '',
      serviceViewport: false,
      lastLoop: new Date(),
      graphicLevel: 0,
      graphicLimit: 4,
      isPage: true,
      fps: 0,
      title: 'Сотби',
      pages: ['home', 'service', 'clients', 'about', 'career', 'contacts'],
      currentPage: '',
      videos: [
        {
          html: 'background0',
          wrap: 'home',
        },
        {
          html: 'background2',
          wrap: 'clients',
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  mounted() {
    this.isPage = this.isPageExist();
    this.$store.dispatch('fetchCities');
    this.$store.dispatch('fetchPage', { lang: this.lang === 0 ? 'ru' : 'en' });

    window.addEventListener('resize', this.disableTransition);

    if (this.firstVisit && !this.themeOnlyWhite && !this.mobile) {
      this.switchedTheme = location.pathname.indexOf('dark') > -1 ? 'white' : 'dark';
      document.addEventListener('scroll', this.showDarkSide);
    }

    if (!this.mobile) {
      const checkFPS = setInterval(this.calcFPS, 100);
      setTimeout(() => {
        clearInterval(checkFPS);
        if (this.browser === 'safari') {
          this.graphicLevel += 2;
        }
        this.initPage();
      }, 3000);
    } else {
      this.initPage();
    }
  },

  watch: {
    lang() {
      const lg = this.lang === 0 ? 'ru' : 'en';
      this.$store.dispatch('fetchPage', { lang: lg });
    },

    page() {
      if (this.animation) {
        this.detectCurrentChapter(true);
      }
    },

    theme() {
      this.updateTitle();
    },

    $route() {
      this.isPage = this.isPageExist();
    },
  },

  methods: {
    isPageExist() {
      const pages = 'home, service, clients, about, career, contacts';
      const modes = 'eng, dark';

      const hasSlash = this.$route.path.slice(-1) === '/' ? 2 : 1;

      const page = this.$route.path.split('/');
      const currentPage = page[page.length - hasSlash];
      return pages.indexOf(currentPage) > -1 || modes.indexOf(currentPage) > -1;
    },

    isRetina() {
      return window.devicePixelRatio > 1;
    },

    initPage() {
      setTimeout(() => {
        this.initVideos();
        if (!this.mobile) {
          document.addEventListener('scroll', this.detectCurrentChapter);
          if (this.currentPage === '') {
            this.title = this.page.home ? this.page.home.title : '';
          }
        }
      }, 100);
    },

    detectCurrentChapter(check) {
      let currentPath = '';
      const lang = this.lang === 0 ? '' : 'eng';
      for (let chap = 0; chap < this.pages.length; chap += 1) {
        const page = this.pages[chap];
        if (inViewport(this.$refs[page], 200)) {
          currentPath = page;
        }
      }
      if (this.currentPage !== currentPath || check) {
        if (currentPath !== '') {
          if (currentPath === 'home') {
            currentPath = '';
            if (this.page.home) {
              this.title = this.page.home.title;
            }
          }
          this.currentPage = currentPath;
          const isDarkPath = `/${lang}${this.checkPath()}/${this.currentPage}/`;
          this.$router.push(isDarkPath.replace('//', '/'));

          if (this.page[this.currentPage]) {
            this.updateTitle();
          } else if (this.currentPage === '') {
            this.title = this.page.home.title;
          }
        }
      }
    },

    updateTitle() {
      if (this.page[this.currentPage]) {
        this.title = this.theme === 'dark' ? this.page[this.currentPage].name : this.page[this.currentPage].title;
      }
    },

    checkPath() {
      let path = '';
      if (this.theme === 'dark') {
        path = '/dark';
      } else if (this.themeOnlyWhite) {
        path = '/white';
      }
      return path;
    },

    initVideos() {
      if (this.$refs.background0) {
        this.$refs.background0.load();
        this.$refs.background0.oncanplay = () => {
          window.addEventListener('scroll', this.checkVideoPlaying);
          this.$store.dispatch('pageIsLoaded');
          setTimeout(() => {
            this.$refs.background0.play();
          }, 5000);
        };
      } else {
        this.$store.dispatch('pageIsLoaded');
      }
      if (this.$refs.background2) {
        this.$refs.background2.load();
        this.$refs.background2.oncanplay = () => {
          setTimeout(() => {
            this.$refs.background0.play();
          }, 5000);
        };
      }
      setTimeout(() => {
        if (!this.animation) {
          this.$store.dispatch('pageIsLoaded');
        }
      }, 5000);
    },

    calcFPS() {
      const thisLoop = new Date();
      this.fps = 1000 / (thisLoop - this.lastLoop);
      this.lastLoop = thisLoop;
      if (this.fps > 1) {
        this.graphicLevel += 1;
      }
    },

    showDarkSide() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        if (!this.themeIsSwitched) {
          this.$store.dispatch('changeTheme', this.switchedTheme);
          document.removeEventListener('scroll', this.showDarkSide);
        }
      }
    },

    checkServiceViewport() {
      if (this.$refs.service) {
        this.serviceViewport = this.$refs.service.classList.contains('in-viewport');
      }
    },

    checkVideoPlaying() {
      for (let v = 0; v < this.videos.length; v += 1) {
        const vid = this.videos[v];
        if (vid && vid.html) {
          const vidEl = this.$refs[vid.html];
          const vidWrap = this.$refs[vid.wrap];
          if (vidEl && vidWrap) {
            if (!inViewport(vidWrap)) {
              if (!vidEl.paused && !vidEl.ended && vidEl.readyState > 2) {
                vidEl.pause();
              }
            } else if (vidEl.currentTime === 0 || vidEl.paused) {
              vidEl.play();
            }
          }
        }
      }
    },

    disableTransition() {
      this.disableAnimation = true;
      clearTimeout(this.animationTimeout);
      this.animationTimeout = setTimeout(() => {
        this.disableAnimation = false;
      }, 200);
    },

    switchPopup() {
      this.$store.dispatch('popupState', !this.popup);
    },
  },
};
</script>

<style>
@font-face {
  font-family: 'Mirta';
  font-style: normal;
  src: url('/static/fonts/ALSMirta-Regular.eot');
  src: url('/static/fonts/ALSMirta-Regular.eot?#iefix') format('embedded-opentype'),
       url('/static/fonts/ALSMirta-Regular.woff2') format('woff2'),
       url('/static/fonts/ALSMirta-Regular.woff') format('woff'),
       url('/static/fonts/ALSMirta-Regular.ttf') format('truetype'),
       url('/static/fonts/ALSMirta-Regular.svg#als_mirtaregular') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Mirta';
  font-style: italic;
  src: url('/static/fonts/als_mirta_italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('/static/fonts/als_mirta_italic.woff2') format('woff2'), /* Super Modern Browsers */
       url('/static/fonts/als_mirta_italic.woff') format('woff'), /* Pretty Modern Browsers */
       url('/static/fonts/als_mirta_italic.ttf')  format('truetype'), /* Safari, Android, iOS */
       url('/static/fonts/als_mirta_italic.svg#svgFontName') format('svg'); /* Legacy iOS */
}


@font-face {
  font-family: 'Direct';
  font-style: normal;
  src: url('/static/fonts/ALS_Direct_Regular.eot'); /* IE9 Compat Modes */
  src: url('/static/fonts/ALS_Direct_Regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('/static/fonts/ALS_Direct_Regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('/static/fonts/ALS_Direct_Regular.woff') format('woff'), /* Pretty Modern Browsers */
       url('/static/fonts/ALS_Direct_Regular.ttf')  format('truetype'), /* Safari, Android, iOS */
       url('/static/fonts/ALS_Direct_Regular.svg#svgFontName') format('svg'); /* Legacy iOS */
}

@font-face {
  font-family: 'icomoon';
  src:  url('/static/fonts/icomoon.eot?2l9wif');
  src:  url('/static/fonts/icomoon.eot?2l9wif#iefix') format('embedded-opentype'),
    url('/static/fonts/icomoon.ttf?2l9wif') format('truetype'),
    url('/static/fonts/icomoon.woff?2l9wif') format('woff'),
    url('/static/fonts/icomoon.svg?2l9wif#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
}


/* Variables defined in the .postcssrc */
#app {
  font-family: 'Mirta';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  max-width: 100%;
  font-size: 16px;
  color: white;
}

.app-loading{
  max-height: 100vh;
}


[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-arrow-left:before {
  content: "\e900";
  font-size: 36px;
}
.icon-arrow-right:before {
  content: "\e901";
  font-size: 36px;
}
.icon-exit:before {
  content: "\e902";
}

@keyframes opaci{
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
body{
  animation: opaci .3s ease-in-out;
  background:$brandDark;
}

h1, h2, h3, h4, h5, ul, p{
  /*animation: show 2s ease-in-out;*/
}

h1{
  -webkit-margin-start: -6px;
  font-size: 1000%;
  line-height: 1;

  @media (max-width: 1500px){
    font-size: 900%;
  }
  @media (max-width: $mediaLaptop) {
    font-size: 800%;
  }
  @media (max-width: $mediaIpad) {
    font-size: 500%;
  }
  @media (max-width: 820px) {
    font-size: 420%;
  }
  @media (max-width: $mediaMini) {
    margin-top: 50px;
    font-size: 320%;
  }
  @media (max-width: $mediaTiny) {
    font-size: 260%;
  }
}

h2{
  margin-bottom: 0;
  font-size: 350%;
  @media (max-width: $mediaIpad) {
    font-size: 280%;
  }
  @media (max-width: $mediaMini) {
    font-size: 200%;
  }
  @media (max-width: $mediaTiny) {
    font-size: 180%;
  }
}

h3{
  font-weight: 400;
  font-size: 300%;
  margin-top: 50px;
  @media (max-width: $mediaIpad) {
    font-size: 250%;
  }
  @media (max-width: $mediaMini) {
    font-size: 200%;
  }
  @media (max-width: $mediaTiny) {
    font-size: 160%;
  }
}

h4{
  text-transform: uppercase;
  letter-spacing: .1em;
  font-weight: bold;
  margin-top: 35px;
  font-size: 100%;
}

p{
  line-height: 1.5;
  margin: 15px 0;
  font-size: 120%;
  @media (max-width: $mediaIpad) {
    font-size: 110%;
  }
  @media (max-width: $mediaMob) {
    font-size: 100%;
  }
}

a{
  color: #ff9933;
  border-bottom: solid 1px rgba(255,153,51,.3);
  transition: color .2s ease-in-out;
  &,
  &:hover{
    text-decoration: none;
  }
  &:hover{
    color: #23a1d1;
    border-bottom-color: rgba(26,161,209,.3);
  }
}

.small{
  font-size: 80%;
  margin-top: -7px;
}

.lead{
  vertical-align: bottom;
  margin-top: 5px;
  margin-bottom: 0;
  font-size: 125%;
  display: table;
  max-width: 70%;
  width: 450px;

  p{
    vertical-align: bottom;
    display: table-cell;
  }

  &-intro{
    min-height: 150px;
    margin-left: 30%;
    max-width: 70%;
    width: 500px;

    @media (max-width: $mediaMob) {
      max-width: 250px;
      font-size: 100%;
    }
    @media (max-width: $mediaTiny) {
      display: none;
    }
  }
}

.background{
  transition: opacity .3s ease-in-out;
  position: absolute;
  min-height: 1200px;
  /*overflow: hidden;*/
  z-index: 10;
  width: 105vw;
  opacity: 0.1;
  left: 0;
  top: 0;

  video{
    visibility: hidden;
    position: absolute;
    min-height: 100vh;
    /*overflow: hidden;*/
    min-width: 100vw;
    transform: none;
    display: none;
    height: auto;
    width: auto;
    left: 50%;
    top: 50%;
  }

  .in-viewport & {
    video{
      transform: translate3d(-50%, -50%, 0);
      visibility: visible;
      display: block;
    }
  }


  &-active{
    opacity: 1;
  }

  &-gif{
    margin-left: 30vw;
  }


  &-video-gradient{
    display: inline-block;
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
      
    &:before,
    &:after{
      position: absolute;
      background: $brandDark;
      z-index: 999;
      height: 100px;
      width: 100%;
      content: '';
      left: 0;
    }

    
    &:before{
      background: linear-gradient(to bottom, $brandDark, rgba(18, 10, 66, 0));
      top: 0;
    }

    &:after{
      background: linear-gradient(to top, $brandDark, rgba(18, 10, 66, 0));
      bottom: 0;
    }
  }

  &-back{
    background: url('/static/sotbi_cover_1.jpg');
    background-size: cover;
    position: relative;
    min-height: 800px;
    overflow: hidden;
    height: 100vh;
    width: 100vw;


    &-white{
      background:rgba(5, 17, 61, 0.29);
      background: url('/static/logo-mask.png') no-repeat;
      background-size: 100% 100%;
      height: 45vw;
      width: 40vw;
      min-height: 200px;
      max-height: 520px;
      max-width: 600px;
      bottom: 0px;

      @media (max-width: $mediaMob) {
        max-height: 450px;
        min-height: 400px;
        bottom: -50px;
      }
      @media (max-width: $mediaMini) {
        min-height: 310px;
        width: 45vw;
      }
      @media (max-width: $mediaTiny) {
        min-height: 160px;
        height: 160px;
        bottom: -70px;
      }
    }
  }

  &-video-second{
    overflow: hidden;
    top: 30vh;
  }
}

@keyframes show{
  from{
    transform: scale(1.1);
    opacity: 0;
  }
  to{
    transform: scale(1);
    opacity: 1;
  }
}

.page{
  -webkit-backface-visibility: hidden;
  transform: translate3d(0,0,0);
  max-width: $whitePageMaxWide;
  padding-left: $whitePanel;
  position: relative;
  z-index: 10;

  width: $whitePageWide;
  /*overflow: hidden;*/
  margin-top: -10px;

  @media (max-width: $mediaIpad) {
    min-width: $whitePageWide;
  }

  @media (max-width: $mediaMini) {
    /*padding-right: 10px;*/
    padding-left: 0;
  }

  &-white{
    color: $brandDark;
    background: white;
  }

  p{
    max-width: 600px;
  }


  &-dark{
    background: transparent;
    color: white;
    .lead{
      h3{
        font-style: italic;
      }
    }
  }

  &-pseudo{
    pointer-events: none;
    position: absolute;
    background: none;
    z-index: 30;
    left: 0;
    top: 0;

    .page-white{
      background: transparent;
      h1,
      h3,
      p{
        visibility: hidden;
        z-index: -1;
        opacity: 0;
      }
    }
  }

  &-back{
    background: transparent;
    position: absolute;
    color: white;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  &-front,
  &-back{
    /*overflow: hidden;*/
    height: 100%;
    z-index: 11;

    .app-high & .page-dark > .container,
    .app-high & .page-white > .container {
      @media (min-width: $mediaTiny) {
        transition: opacity .5s ease-in-out;
        transform: translate3d(0, 20px, 0);
        visibility: hidden;
        opacity: 0;
      }
    }

    .global-visibility.app-high &,
    .app-high &.in-viewport,
    .app-high .in-viewport &{
      .page-dark > .container,
      .page-white > .container {
        visibility: visible;
        transform: none;
        opacity: 1;
      }
    }
  }

  &-front{
    position: relative;
    overflow: hidden;

    &-contacts{
      z-index: 20;
    }

    .global-visibility &,
    &.in-viewport,
    .in-viewport &{
      transition: max-width $mainAnimationTime $mainAnimationTransition;
    }
  }

  &-visible{
    overflow: visible;
  }

  &-mask{
    z-index: -1;
    padding-left: 0;
    overflow: hidden;
    margin-top: -20px;

    margin-bottom: -20px;
    display: inline-block;

    @media (max-width: $mediaIpad) {
      margin-top: -2px;
    }

    @media (max-width: 500px) {
      margin-bottom: -17px;
      .app-low &{
        margin-bottom: -2px;
      }
    }

    .app-mozilla & {
      margin-bottom: -20px;
    }

    &--back{
      position: relative;
      height: auto;
      width: 100.1%;
      top: -1px;

      path{
        fill: white;
      }
    }
  }

  &-theme{
    /*visibility: hidden;*/
    position: relative;
    display: block;
    width: 100%;


    &-white{
      .page-front{
        max-width: $whitePageMaxWide;
        @media (max-width: $whitePageMaxWide){
          max-width: 90vw;
        }
      }

      .theme-switching-ending & .page-back{
        visibility: hidden;
      }

      .page-back{
        @media (max-width: $mediaSmallScreen) {
          transition: opacity .3s ease-in-out;
          transition-delay: 1.5s;
          opacity: 0;
        }

        .theme-switching-ending & h1{
          opacity: 0;
        }
      }
    }
    &-dark{
      .page-front{
          &,
          .background-mask{
            max-width: $whitePanel;
            @media (max-width: $mediaMini) {
              max-width: 0;
            }
          }
      }
      .page-back{
        @media (max-width: $mediaMob) {
          transition: opacity .3s ease-in-out;
          opacity: 1;
        }
        max-width: 100vw;
      }
    }
  }

  .container{
    max-width: 95%;
  }
}

.popup{
  transition: opacity .3s ease-in-out;
  position: fixed;
  z-index: 990;
  opacity: 0;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;

  &-active{
    opacity: 1;
  }

  &-back{
    /*background: rgba(0, 190, 255, 0.75);*/
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;

  }
}

.preloader--mini{
  position: fixed;
  z-index: 999;
  bottom: 10px;
  height: 30px;
  width: 30px;
  left: 47%;
  img{
    max-width: 100%;
    height: auto;
  }
}

.hello--logo,
.logo-compensation{
  display: inline-block;
  position: relative;
  max-width: 560px;
  width: 50vw;
  opacity: 1;

  @media (max-width: $mediaIpad) {
    width: 40vw;
  }
}

.logo-compensation{
  @media (max-width: $mediaMob) {
    display: none;
  }
}

.font-grotesque{
  font-family: 'Direct', Helvetica, Arial, sans-serif;
}

.font-antique{
  font-family: 'Mirta', Helvetica, Arial, sans-serif;
}

.no-scroll{
  overflow: hidden;
  height: 100vh;

  .header-background{
    opacity: 0;
  }
}

.comment{
  font-size: 80%;
  margin-top: -13px;
}

.uppercase{
  text-transform: uppercase;
  letter-spacing: .1em;
  font-weight: 600;
  &,
  p,
  li{
    font-size: 12px;
    @media (min-width: $mediaLaptop) {
      font-size: 14px;
    }
  }
}

.disable-animation *{
  transition: none !important;
}

.animation{
  z-index: 40;
  @media (max-width: $mediaMini) {
    display: none;
  }
  svg{
    transform-box: border-box;
  }
}

.map-standard{
  transition: all 1s ease-in-out;
  position: relative;
  z-index: 12;
  top: 0;

  .page-theme-dark &{
    pointer-events: none;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue